(function armorCollectionV2Bootstrap() {
  'use strict';

  var ROOT_SELECTOR = '[data-armor-collection-v2]';
  var instances = new WeakMap();

  function rootsWithin(container) {
    var roots = [];
    if (!container) return roots;
    if (container.matches && container.matches(ROOT_SELECTOR)) roots.push(container);
    if (container.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(container.querySelectorAll(ROOT_SELECTOR)));
    }
    return roots;
  }

  function parseVariants(card) {
    var payload = card.querySelector('[data-collection-variants]');
    if (!payload) return [];

    try {
      var variants = JSON.parse(payload.textContent);
      return Array.isArray(variants) ? variants : [];
    } catch (error) {
      return [];
    }
  }

  function findVariant(variants, id) {
    return variants.find(function matchVariant(variant) {
      return String(variant.id) === String(id);
    });
  }

  function setText(element, value) {
    if (element) element.textContent = value == null ? '' : String(value);
  }

  function setVariantUrl(card, url) {
    if (!url) return;
    card.querySelectorAll('[data-collection-product-link]').forEach(function updateLink(link) {
      link.setAttribute('href', url);
    });
  }

  function updateCard(card, variant) {
    if (!variant) return;

    var price = card.querySelector('[data-collection-price]');
    var comparePrice = card.querySelector('[data-collection-compare-price]');
    var availability = card.querySelector('[data-collection-availability]');
    var variantInput = card.querySelector('[data-collection-variant-input]');
    var quantityInput = card.querySelector('[data-collection-quantity-input]');
    var addButton = card.querySelector('[data-collection-add-button]');
    var addLabel = card.querySelector('[data-collection-add-label]');
    var soldOutMessage = addButton ? addButton.querySelector('.sold-out-message') : null;
    var isAvailable = variant.available === true;

    setText(price, variant.price);

    if (comparePrice) {
      var hasComparePrice =
        typeof variant.compareAtPrice === 'string' && variant.compareAtPrice.trim() !== '';
      comparePrice.hidden = !hasComparePrice;
      setText(comparePrice, hasComparePrice ? variant.compareAtPrice : '');
    }

    if (availability) {
      availability.dataset.state = isAvailable ? 'available' : 'sold-out';
      setText(
        availability,
        isAvailable
          ? card.dataset.labelAvailable || 'Available'
          : card.dataset.labelSoldOut || 'Sold out'
      );
    }

    if (variantInput) variantInput.value = String(variant.id);
    if (quantityInput) quantityInput.value = String(variant.quantityMin || 1);

    if (addButton) {
      addButton.disabled = !isAvailable;
      addButton.toggleAttribute('aria-disabled', !isAvailable);
      if (addLabel) {
        addLabel.classList.remove('hidden');
        setText(
          addLabel,
          isAvailable
            ? card.dataset.labelAddToCart || 'Add to cart'
            : card.dataset.labelSoldOut || 'Sold out'
        );
      }
      if (soldOutMessage) soldOutMessage.classList.add('hidden');
    }

    setVariantUrl(card, variant.url);
  }

  function attachProductCard(card, registerCleanup) {
    var picker = card.querySelector('[data-collection-variant-picker]');
    if (!picker) return;

    var variants = parseVariants(card);
    if (!variants.length) return;

    function handleVariantChange() {
      updateCard(card, findVariant(variants, picker.value));
    }

    picker.addEventListener('change', handleVariantChange);
    registerCleanup(function removeVariantListener() {
      picker.removeEventListener('change', handleVariantChange);
    });

    handleVariantChange();
  }

  function init(root) {
    if (!root || instances.has(root)) return;

    var cleanups = [];
    function registerCleanup(cleanup) {
      cleanups.push(cleanup);
    }

    root.querySelectorAll('[data-collection-product-card]').forEach(function attach(card) {
      attachProductCard(card, registerCleanup);
    });

    instances.set(root, {
      destroy: function destroy() {
        cleanups.forEach(function runCleanup(cleanup) {
          cleanup();
        });
        cleanups = [];
        instances.delete(root);
      }
    });
  }

  function initWithin(container) {
    rootsWithin(container).forEach(init);
  }

  function destroyWithin(container) {
    rootsWithin(container).forEach(function destroyRoot(root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function onReady() {
        initWithin(document);
      },
      { once: true }
    );
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', function onSectionLoad(event) {
    initWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function onSectionUnload(event) {
    destroyWithin(event.target);
  });
})();
